import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss']
})
export class BackToTopComponent implements OnInit {
  utils: any;
  constructor() {
    this.utils = window.utils;
  }
  ngOnInit() {
    this.utils.init();
    window.utils.onWindowScroll();
  }
  scrollToTop(){
    this.utils.scrollToTop();
  }
}
